import { createFileRoute, useRouter } from '@tanstack/react-router';
import { RequireService } from '@/components/shared/require-service';
import { RouteErrorBoundary } from '@/components/shared/RouteErrorBoundary';
import { OverviewPage as OverviewPageContent } from '@/features/overview/overview-page';

function OverviewPage() {
  return (
    <RequireService service="DASHBOARD_VIEW">
      <OverviewPageContent />
    </RequireService>
  );
}

/**
 * Rule CR2: the first of "each top-level feature route" — the model every
 * future page under `_app` copies. Scoped to this route only (rule CR5), so
 * a crash here never costs the `_app` layout's own sidebar and header (rule
 * CR2's "leaves the navigation sidebar, the top bar ... intact"), which a
 * boundary declared only on `_app` itself could not guarantee on its own.
 */
function OverviewErrorBoundary({ error }: { error: unknown }) {
  const router = useRouter();
  return (
    <RouteErrorBoundary
      error={error}
      boundary="overview"
      onRetry={() => void router.invalidate()}
    />
  );
}

export const Route = createFileRoute('/_app/')({
  component: OverviewPage,
  errorComponent: OverviewErrorBoundary,
});
